import { responsiveVanillaSelector } from '../selectors';
import type { Site } from '../Site';

export const GamesRadar: Site = {
  id: 'gamesradar',
  logo: 'svg/gamesradar.svg',
  label: 'GamesRadar',
  analyticsName: 'grd',
  hostname: 'gamesradar.com',
  platform: 'responsive',
  selector: responsiveVanillaSelector,
};
